interface CheckCircleIconProps {
  className?: string;
}

export function CheckCircleIcon({ className }: CheckCircleIconProps) {
  return (
    <svg
      width="28.8"
      height="28.8"
      viewBox="0 0 28.8 28.8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_check_circle"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="29"
        height="29"
      >
        <rect width="28.8" height="28.8" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_check_circle)">
        <path
          d="M12.72 19.92L21.18 11.46L19.5 9.78L12.72 16.56L9.30001 13.14L7.62001 14.82L12.72 19.92ZM14.4 26.4C12.74 26.4 11.18 26.085 9.72001 25.455C8.26001 24.825 6.99001 23.97 5.91001 22.89C4.83001 21.81 3.97501 20.54 3.34501 19.08C2.71501 17.62 2.40001 16.06 2.40001 14.4C2.40001 12.74 2.71501 11.18 3.34501 9.72C3.97501 8.26 4.83001 6.99 5.91001 5.91C6.99001 4.83 8.26001 3.975 9.72001 3.345C11.18 2.715 12.74 2.4 14.4 2.4C16.06 2.4 17.62 2.715 19.08 3.345C20.54 3.975 21.81 4.83 22.89 5.91C23.97 6.99 24.825 8.26 25.455 9.72C26.085 11.18 26.4 12.74 26.4 14.4C26.4 16.06 26.085 17.62 25.455 19.08C24.825 20.54 23.97 21.81 22.89 22.89C21.81 23.97 20.54 24.825 19.08 25.455C17.62 26.085 16.06 26.4 14.4 26.4ZM14.4 24C17.08 24 19.35 23.07 21.21 21.21C23.07 19.35 24 17.08 24 14.4C24 11.72 23.07 9.45 21.21 7.59C19.35 5.73 17.08 4.8 14.4 4.8C11.72 4.8 9.45001 5.73 7.59001 7.59C5.73001 9.45 4.80001 11.72 4.80001 14.4C4.80001 17.08 5.73001 19.35 7.59001 21.21C9.45001 23.07 11.72 24 14.4 24Z"
          fill="#DED287"
        />
      </g>
    </svg>
  );
}
